// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__26uih","requiredAsterisk":"Info_requiredAsterisk__2Woi0"};